
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_802_1512)"}},[_c('path',{attrs:{"d":"M30 0H0v10h30V0z","fill":"#fff"}}),_c('path',{attrs:{"d":"M30 10H0v10h30V10z","fill":"#DC143C"}})]),_c('rect',{attrs:{"x":".25","y":"-.25","width":"29.5","height":"19.5","rx":"2.75","transform":"matrix(1 0 0 -1 0 19.5)","stroke":"#F2F2F2","stroke-width":".5"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_802_1512"}},[_c('rect',{attrs:{"width":"30","height":"20","rx":"3","transform":"matrix(1 0 0 -1 0 20)","fill":"#fff"}})])])])
          )
        }
      }
    